import { ConsumablesProductDetailsContainerComponent } from "@/components/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.builder";
import { ProductSpecificationComponent } from "@/components/ProductSpecification/ProductSpecification.builder";
import { ProductTeaserCarouselComponent } from "@/components/ProductTeaserCarousel/ProductTeaserCarousel.builder";
import { StandardProductDetailsContainerComponent } from "@/components/StandardProductDetailsContainer/StandardProductDetailsContainer.builder";
import { SticksProductDetailsContainerComponent } from "@/components/SticksProductDetailsContainer/SticksProductDetailsContainer.builder";

export const productCustomComponents: RegisteredComponent[] = [
  ConsumablesProductDetailsContainerComponent,
  SticksProductDetailsContainerComponent,
  ProductSpecificationComponent,
  ProductTeaserCarouselComponent,
  StandardProductDetailsContainerComponent,
];
